import React, { useState, useEffect } from 'react'
import Slider from 'react-slick';
import { useNavigate } from 'react-router-dom';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Range, getTrackBackground } from 'react-range';
import { formatPrice } from '../../utils/formatPrice';
import {
  getCategoriasPadres,
  getPrecioRango,
  getMarcas,
  getProcesadores,
  getStorages,
  getGraficos,
  getRams,
  getProductosFiltrados
} from '../../actions/home';

const sliderSettings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 2,
  arrows: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2.5,
        slidesToScroll: 2.5,
      },
    },
    {
      breakpoint: 393,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

// Componente CategoryFilter
const CategoryFilter = ({ categories, selectedCategories, onCategoryClick }) => (
  <div className='category-filter'>
    <h3>Categorías</h3>
    <Slider {...sliderSettings} className='custom-slider'>
      {categories.map((category) => (
        <button
          key={category.categoriaCodigo}
          id={`filter-button`}
          className={`${selectedCategories.includes(category.categoriaCodigo) ? 'selected' : ''}`}
          onClick={() => onCategoryClick(category.categoriaCodigo)}
        >
          {category.categoriaDescripcion}
        </button>
      ))}
    </Slider>
  </div>
);

// Componente BrandFilter
const BrandFilter = ({ brands, selectedBrands, onBrandClick }) => (
  <div className='category-filter'>
    <h3>Marca</h3>
    <Slider {...sliderSettings} className='custom-slider'>
      {brands.map((brand) => (
        <button
          key={brand.marcaId}
          id={`filter-button`}
          className={`${selectedBrands.includes(brand.marcaId) ? 'selected' : ''}`}
          onClick={() => onBrandClick(brand.marcaId)}
        >
          {brand.marcaDescripcion}
        </button>
      ))}
    </Slider>
  </div>
);

// Componente PriceFilter
const PriceFilter = ({ priceRange, selectedPrice, setSelectedPrice }) => {
  const STEP = 10;
  const MIN = priceRange.min;
  const MAX = priceRange.max;

  useEffect(() => {
    // setSelectedPrice([MIN, MAX]); // Reinicia el rango seleccionado cuando cambie el rango
  }, [priceRange, setSelectedPrice, MIN, MAX]);

  return (
    <div>
      <h3>Filtrar por precio</h3>
      <Range
        values={selectedPrice}
        step={STEP}
        min={MIN}
        max={MAX}
        onChange={setSelectedPrice}
        renderTrack={({ props, children }) => (
          <div
            {...props}
            style={{
              ...props.style,
              height: '10px',
              width: '100%',
              background: getTrackBackground({
                values: selectedPrice,
                colors: ['#C5C5C5', '#1B09E8', '#C5C5C5'],
                min: MIN,
                max: MAX
              }),
              borderRadius: '5px',
              margin: '1em 0'
            }}
          >
            {children}
          </div>
        )}
        renderThumb={({ props }) => (
          <div
            {...props}
            style={{
              ...props.style,
              height: '18px',
              width: '18px',
              borderRadius: '50%',
              backgroundColor: '#1B09E8',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              boxShadow: '0px 2px 6px #AAA'
            }}
          />
        )}
      />
      <div className="price-values" style={{ display: 'flex', justifyContent: 'space-between', fontSize: '10px', fontWeight: '600' }}>
        <span>{formatPrice(selectedPrice[0])}</span>
        <span>{formatPrice(selectedPrice[1])}</span>
      </div>
    </div>
  );
};

// Componente ProcessorFilter
const ProcessorFilter = ({ processors, selectedProcessors, onProcessorClick }) => (
  <div>
    <h3>Modelo de Procesador</h3>
    <Slider {...sliderSettings} className='custom-slider'>
      {processors.map((processor) => (
        <button
          key={processor.modeloprocesadorId}
          id={`filter-button`}
          className={`${selectedProcessors.includes(processor.modeloProcesadorId) ? 'selected' : ''}`}
          onClick={() => onProcessorClick(processor.modeloProcesadorId)}
        >
          {processor.modeloProcesadorDescripcion}
        </button>
      ))}
    </Slider>
  </div>
);

// Componente RamFilter
const RamFilter = ({ ram, selectedRam, onRamClick }) => (
  <div>
    <h3>Memoria Ram</h3>
    <Slider {...sliderSettings} className='custom-slider'>
      {ram.map((ramOption) => (
        <button
          key={ramOption.ramId}
          id={`filter-button`}
          className={`${selectedRam.includes(ramOption.ramId) ? 'selected' : ''}`}
          onClick={() => onRamClick(ramOption.ramId)}
        >
          {ramOption.ramDescripcion}
        </button>
      ))}
    </Slider>
  </div>
);

// Componente StorageFilter
const StorageFilter = ({ storage, selectedStorage, onStorageClick }) => (
  <div>
    <h3>Almacenamiento</h3>
    <Slider {...sliderSettings} className='custom-slider'>
      {storage.map((storageOption) => (
        <button
          key={storageOption.almacenamientoId}
          id={`filter-button`}
          className={`${selectedStorage.includes(storageOption.almacenamientoId) ? 'selected' : ''}`}
          onClick={() => onStorageClick(storageOption.almacenamientoId)}
        >
          {storageOption.almacenamientoDescripcion}
        </button>
      ))}
    </Slider>
  </div>
);

// Componente GraphicsFilter
const GraphicsFilter = ({ graphics, selectedGraphics, onGraphicsClick }) => (
  <div>
    <h3>Gráficos</h3>
    <Slider {...sliderSettings} className='custom-slider'>
      {graphics.map((graphicsOption, index) => (
        <button
          key={graphicsOption.graficosId}
          id={`filter-button`}
          className={`${selectedGraphics.includes(graphicsOption.graficosId) ? 'selected' : ''}`}
          onClick={() => onGraphicsClick(graphicsOption.graficosId)}
        >
          {graphicsOption.graficosDescripcion}
        </button>
      ))}
    </Slider>
  </div>
);

export const ContenidoFiltro = ({ onCloseContenido, categoriaCodigo, onApplyFilters = () => { } }) => {
  const [selectedCategories, setSelectedCategories] = useState([])
  const [categories, setCategories] = useState([])
  const [selectedBrands, setSelectedBrands] = useState([])
  const [brands, setBrands] = useState([])
  const [selectedProcessors, setSelectedProcessors] = useState([])
  const [selectedRam, setSelectedRam] = useState([])
  const [selectedStorage, setSelectedStorage] = useState([])
  const [selectedGraphics, setSelectedGraphics] = useState([])
  const [priceRange, setPriceRange] = useState({ min: 0, max: 1000000 })
  const [selectedPrice, setSelectedPrice] = useState([0, 0])
  const [processors, setProcessors] = useState([])
  const [ram, setRam] = useState([])
  const [storage, setStorage] = useState([])
  const [graphics, setGraphics] = useState([])

  const navigate = useNavigate()

  // Cargar las categorías al montar el componente
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const fetchedCategories = await getCategoriasPadres()
        setCategories(fetchedCategories)
      } catch (error) {
        console.error('Error al obtener las categorías padres:', error)
      }
    };
    fetchCategories()
  }, [])

  useEffect(() => {
    if (categoriaCodigo) {
      setSelectedCategories([categoriaCodigo]);
    }
  }, [categoriaCodigo]);

  // Dentro del componente ContenidoFiltro
  useEffect(() => {
    applyFilters();
  }, [selectedCategories, selectedBrands, selectedProcessors, selectedRam, selectedStorage, selectedGraphics, selectedPrice]);

  // Obtener rango de precios basado en la categoría seleccionada
  useEffect(() => {
    const fetchPriceRange = async () => {
      try {
        if (categoriaCodigo) {
          const rangoPrecios = await getPrecioRango(categoriaCodigo)
          setPriceRange({ min: rangoPrecios.minPrice, max: rangoPrecios.maxPrice })
          setSelectedPrice([rangoPrecios.minPrice, rangoPrecios.maxPrice]) // Reiniciar el rango seleccionado
        } else {
          const rangoGlobal = await getPrecioRango()
          setPriceRange({ min: rangoGlobal.minPrice, max: rangoGlobal.maxPrice })
          setSelectedPrice([rangoGlobal.minPrice, rangoGlobal.maxPrice])
        }
      } catch (error) {
        console.error('Error al obtener el rango de precios:', error)
      }
    };

    fetchPriceRange()
  }, [categoriaCodigo])

  // Obtener marcas según la categoría seleccionada
  useEffect(() => {
    const fetchMarcas = async () => {
      try {
        const fetchedMarcas = categoriaCodigo
          ? await getMarcas(categoriaCodigo)
          : await getMarcas()
        setBrands(fetchedMarcas)
      } catch (error) {
        console.error('Error al obtener marcas:', error)
      }
    }
    fetchMarcas()
  }, [categoriaCodigo])

  useEffect(() => {
    const fetchProcesadores = async () => {
      try {
        const fetchedProcesadores = categoriaCodigo
          ? await getProcesadores(categoriaCodigo)
          : await getProcesadores()
        setProcessors(fetchedProcesadores)
        setSelectedProcessors([])
      } catch (error) {
        console.error('Error al obtener procesadores:', error)
      }
    };

    fetchProcesadores()
  }, [categoriaCodigo])

  useEffect(() => {
    const fetchRam = async () => {
      try {
        const fetchedRam = categoriaCodigo
          ? await getRams(categoriaCodigo)
          : await getRams()
        setRam(fetchedRam)
        setSelectedRam([])
      } catch (error) {
        console.error('Error al obtener RAM:', error)
      }
    };

    fetchRam()
  }, [categoriaCodigo])

  useEffect(() => {
    const fetchStorage = async () => {
      try {
        const fetchedStorage = categoriaCodigo
          ? await getStorages(categoriaCodigo)
          : await getStorages()
        setStorage(fetchedStorage)
        setSelectedStorage([])
      } catch (error) {
        console.error('Error al obtener almacenamiento:', error)
      }
    };

    fetchStorage()
  }, [categoriaCodigo])

  useEffect(() => {
    const fetchGraphics = async () => {
      try {
        const fetchedGraphics = categoriaCodigo
          ? await getGraficos(categoriaCodigo)
          : await getGraficos();
        setGraphics(fetchedGraphics);
        setSelectedGraphics([])
      } catch (error) {
        console.error('Error al obtener gráficos:', error);
      }
    }

    fetchGraphics();
  }, [categoriaCodigo])

  const handleFilterClick = (filterType, filterValue) => {
    switch (filterType) {
      case 'category':
        setSelectedCategories([filterValue]);
        break;
      case 'brand':
        setSelectedBrands(prev =>
          prev.includes(filterValue)
            ? prev.filter(brand => brand !== filterValue)
            : [...prev, filterValue]
        );
        break;
      case 'processor':
        setSelectedProcessors(prev =>
          prev.includes(filterValue)
            ? prev.filter(proc => proc !== filterValue)
            : [...prev, filterValue]
        );
        break;
      case 'ram':
        setSelectedRam(prev =>
          prev.includes(filterValue)
            ? prev.filter(r => r !== filterValue)
            : [...prev, filterValue]
        );
        break;
      case 'storage':
        setSelectedStorage(prev =>
          prev.includes(filterValue)
            ? prev.filter(s => s !== filterValue)
            : [...prev, filterValue]
        );
        break;
      case 'graphics':
        setSelectedGraphics(prev =>
          prev.includes(filterValue)
            ? prev.filter(g => g !== filterValue)
            : [...prev, filterValue]
        );
        break;
      default:
        break;
    }

    // applyFilters();
  };

  const handlePriceChange = (values) => {
    setSelectedPrice(values)
    // applyFilters();
  };

  const applyFilters = async () => {
    try {
      const currentParams = new URLSearchParams(window.location.search)

      if (selectedCategories.length > 0) {
        // currentParams.set('categoria', selectedCategories.join(','));
        currentParams.set('categoria', selectedCategories[0])
      } else if (categoriaCodigo) {
        currentParams.set('categoria', categoriaCodigo)
      } else {
        currentParams.delete('categoria')
      }

      if (selectedBrands.length > 0) {
        currentParams.set('marca', selectedBrands.join(','))
      } else {
        currentParams.delete('marca')
      }

      if (selectedProcessors.length > 0) {
        currentParams.set('modeloprocesador', selectedProcessors.join(','))
      } else {
        currentParams.delete('modeloprocesador')
      }

      if (selectedRam.length > 0) {
        currentParams.set('ram', selectedRam.join(','))
      } else {
        currentParams.delete('ram')
      }

      if (selectedStorage.length > 0) {
        currentParams.set('almacenamiento', selectedStorage.join(','))
      } else {
        currentParams.delete('almacenamiento')
      }

      if (selectedGraphics.length > 0) {
        currentParams.set('graficos', selectedGraphics.join(','))
      } else {
        currentParams.delete('graficos')
      }

      // currentParams.set('precioMin', selectedPrice[0])
      // currentParams.set('precioMax', selectedPrice[1])

      if (selectedPrice[0] !== priceRange.min || selectedPrice[1] !== priceRange.max) {
        currentParams.set('precioMin', selectedPrice[0]);
        currentParams.set('precioMax', selectedPrice[1]);
      } else {
        currentParams.delete('precioMin');
        currentParams.delete('precioMax');
      }

      navigate(`/catalogo-producto?${currentParams.toString()}`)

      const filteredProducts = await getProductosFiltrados(
        selectedCategories.length > 0 ? selectedCategories[0] : undefined,
        undefined,
        undefined, 
        selectedBrands.length > 0 ? selectedBrands : undefined,
        selectedProcessors.length > 0 ? selectedProcessors : undefined,
        selectedStorage.length > 0 ? selectedStorage : undefined,
        selectedRam.length > 0 ? selectedRam : undefined,
        selectedGraphics.length > 0 ? selectedGraphics : undefined,
        (selectedPrice[0] !== priceRange.min || selectedPrice[1] !== priceRange.max)
          ? selectedPrice[0]
          : undefined,
        (selectedPrice[0] !== priceRange.min || selectedPrice[1] !== priceRange.max)
          ? selectedPrice[1]
          : undefined
      )

      onApplyFilters({ productos: filteredProducts })
    } catch (error) {
      console.error('Error al aplicar filtros:', error)
    }
  }

  const handleClearFilters = () => {
    if (categoriaCodigo) {
      setSelectedBrands([]);
      setSelectedProcessors([]);
      setSelectedRam([]);
      setSelectedStorage([]);
      setSelectedGraphics([]);
      setSelectedPrice([priceRange.min, priceRange.max]);
    } else {
      setSelectedCategories([]);
      setSelectedBrands([]);
      setSelectedProcessors([]);
      setSelectedRam([]);
      setSelectedStorage([]);
      setSelectedGraphics([]);
      setSelectedPrice([priceRange.min, priceRange.max]);
    }
  }

  return (
    <>
      <div className="filter-header">
        <button onClick={onCloseContenido} id="close-button"> &lt; </button>
        <h2>Filtros</h2>
        <h3
          className='font12-semibold pointer'
          onClick={handleClearFilters}
        >
          Limpiar
        </h3>
      </div>
      <div className="filter-content">
        <CategoryFilter
          categories={categories} // aqui se pasan las categorias
          selectedCategories={selectedCategories}
          onCategoryClick={(category) => handleFilterClick('category', category)}
        />
        {priceRange.min !== priceRange.max && (
          <PriceFilter
            priceRange={priceRange}
            selectedPrice={selectedPrice}
            setSelectedPrice={handlePriceChange}
            onChange={setSelectedPrice}
          />
        )}
        <BrandFilter
          brands={brands}
          selectedBrands={selectedBrands}
          onBrandClick={(brand) => handleFilterClick('brand', brand)}
        />
        {processors.length > 0 && (
          <ProcessorFilter
            processors={processors}
            selectedProcessors={selectedProcessors}
            onProcessorClick={(processor) => handleFilterClick('processor', processor)}
          />
        )}
        {ram.length > 0 && (
          <RamFilter
            ram={ram}
            selectedRam={selectedRam}
            onRamClick={(ramOption) => handleFilterClick('ram', ramOption)}
          />
        )}
        {storage.length > 0 && (
          <StorageFilter
            storage={storage}
            selectedStorage={selectedStorage}
            onStorageClick={(storageOption) => handleFilterClick('storage', storageOption)}
          />
        )}
        {graphics.length > 0 && (
          <GraphicsFilter
            graphics={graphics}
            selectedGraphics={selectedGraphics}
            onGraphicsClick={(graphicsOption) => handleFilterClick('graphics', graphicsOption)}
          />
        )}
      </div>
    </>
  )
}
